import React, { useState } from "react";
import { Container, Row, Col } from "react-bootstrap";
import "./Banner.css";
import {
  FaPlayCircle,
  FaArrowRight,
  FaCheckCircle,
  FaGlobe,
  FaShieldAlt,
  FaHeadset,
} from "react-icons/fa";
import { motion } from "framer-motion";

const Banner = () => {
  const [showModal, setShowModal] = useState(false);

  const bannerStats = [
    { icon: <FaCheckCircle />, text: "UpTo 90% Royalty" },
    { icon: <FaGlobe />, text: "150+ Platforms" },
    { icon: <FaShieldAlt />, text: "Fast & Secure" },
    { icon: <FaHeadset />, text: "24/7 Support" },
  ];

  return (
    <section className="banner-section-container position-relative hero_banner">
      <div className="banner-video-wrapper">
        <video 
          autoPlay 
          loop 
          muted 
          playsInline 
          className="banner-video"
        >
          <source src="https://www.pexels.com/download/video/31540265/" type="video/mp4" />
        </video>
        <div className="banner-video-overlay"></div>
      </div>
      <Container className="r-container position-relative">
        <Row className="h-100 align-items-center">
          {/* Left Column: Title, Copy, Action Buttons, Core Features */}
          <Col lg={7} md={12} className="text-start">
            <div className="d-flex flex-column gap-3">
              {/* Trust Badge */}
              <motion.div
                initial={{ opacity: 0, x: -30 }}
                animate={{ opacity: 1, x: 0 }}
                transition={{ duration: 0.6 }}
                className="trusted-badge-premium"
              >
                <span className="dot-pulse"></span>
                Trusted by 10K+ Artists Worldwide
              </motion.div>

              {/* Main Heading */}
              <motion.h1
                initial={{ opacity: 0, y: 30 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.8, delay: 0.2 }}
                className="main-heading-premium"
              >
                Leading Music <br />
                Distribution <br />
                Company <span className="text-purple-gradient">in India</span>
              </motion.h1>

              {/* Subheading Description */}
              <motion.p
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6, delay: 0.4 }}
                className="banner-description-premium mt-2"
              >
                Distribute your music across top streaming platforms like
                Spotify, JioSaavn, Wynk Music, YouTube Music, Hungama Music,
                Gaana and Apple Music with FT Tunes – the best global music
                distribution company in India for artists.
              </motion.p>

              {/* Action Buttons */}
              <motion.div
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6, delay: 0.6 }}
                className="d-flex flex-sm-row flex-column gap-4 mt-4"
              >
                <a
                  href="https://dashboard.fttunes.com/register.php"
                  className="btn-premium-purple button_button__MFmXH button_color__bLscP"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  DISTRIBUTE MY MUSIC NOW <FaArrowRight className="ms-2" />
                </a>
                <button
                  type="button"
                  className="btn-premium-outline"
                  onClick={() => setShowModal(true)}
                >
                  <FaPlayCircle className="me-2" /> HOW IT WORKS
                </button>
              </motion.div>

              {/* Stats Row */}
              <motion.div
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6, delay: 0.8 }}
                className="banner-stats-row mt-5"
              >
                {bannerStats.map((stat, index) => (
                  <div key={index} className="banner-stat-item">
                    <span className="stat-icon">{stat.icon}</span>
                    <span className="stat-text">{stat.text}</span>
                  </div>
                ))}
              </motion.div>
            </div>
          </Col>
        </Row>
      </Container>

      {/* Video Preview Modal */}
      {showModal && (
        <div
          className="modal fade show bg-overlay"
          style={{
            display: "block",
            background: "rgba(0,0,0,0.9)",
            zIndex: 1050,
          }}
          onClick={() => setShowModal(false)}
        >
          <div
            className="modal-dialog modal-dialog-centered modal-lg"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="modal-content bg-black border-0 rounded-4 overflow-hidden">
              <div className="modal-body p-0">
                <video
                  src="/Images/fttunes_dashboard.mp4"
                  controls
                  autoPlay
                  style={{ width: "100%", height: "450px", border: "none", objectFit: "cover" }}
                ></video>
                {/* <iframe
                  className="ifr-video"
                  src="https://youtu.be/XywfeRCSPt8"
                  title="YouTube video player"
                  allow="autoplay; encrypted-media"
                  style={{ width: "100%", height: "450px", border: "none" }}
                /> */}
              </div>
            </div>
          </div>
        </div>
      )}
    </section>
  );
};

export default Banner;
